class InternalOfficeBankAccount {
    id = null;
    name = '';
    internal_office_id = null;
    swift_code = '';
    bank_name = '';
    bank_address = null;
    bank_town = '';
    bank_post_code = '';
    country_id = null;
    bic = '';
    account_holder_name = '';
    iban = '';
    currency_id = null;

    constructor(data, validation = false) {
        for (const [key, value] of Object.entries(data)) {
            this[key] = value;
        }

        if (validation) {
            for (const [key] of Object.entries(this)) {
                this[key] = true;
            }
        }
    }
}

export default InternalOfficeBankAccount;
